export default __webpack_public_path__ + "static/left-bg-5a92d32139ec6333c1fbcd9fa038e44e.png";